const icons = [
  // Base pins without badges
  {
    name: 'pin-blue-base',
    width: 41,
    height: 58,
    content:
      '<svg width="41" height="58" viewBox="0 0 41 58" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="20.5" cy="53.5" rx="11.5" ry="4.5" fill="rgba(217,217,217,0.5)" /><path d="M41 20.6847C41 32.1085 20.5 53.1892 20.5 53.1892C20.5 53.1892 0 32.1085 0 20.6847C0 9.26085 9.17816 0 20.5 0C31.8218 0 41 9.26085 41 20.6847Z" stroke="rgb(128,140,148)" stroke-width="1" fill="rgb(1,78,126)" /></svg>',
  },
  {
    name: 'pin-red-base',
    width: 41,
    height: 58,
    content:
      '<svg width="41" height="58" viewBox="0 0 41 58" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="20.5" cy="53.5" rx="11.5" ry="4.5" fill="rgba(217,217,217,0.5)" /><path d="M41 20.6847C41 32.1085 20.5 53.1892 20.5 53.1892C20.5 53.1892 0 32.1085 0 20.6847C0 9.26085 9.17816 0 20.5 0C31.8218 0 41 9.26085 41 20.6847Z" stroke="rgb(128,140,148)" stroke-width="1" fill="rgb(233,105,88)" /></svg>',
  },
  {
    name: 'badge-white',
    width: 41,
    height: 16,
    content:
      '<svg width="41" height="16" viewBox="0 0 41 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0" width="41" height="16" rx="4" fill="rgb(255,255,255)" /></svg>',
  },
  {
    name: 'gold-star',
    width: 16,
    height: 16,
    content:
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0L9.96 5.2L16 6L12 10L13.08 16L8 13L2.92 16L4 10L0 6L6.04 5.2L8 0Z" fill="rgb(201,168,124)" /></svg>',
  },
];

export default icons;
